import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import ReactTooltip from 'react-tooltip'

const messages = defineMessages({
  benefit: {
    id: 'checkout.benefit3',
    defaultMessage:
      'If you find the same trip for a lower price elsewhere, just let us know and we`ll beat that price – simple',
  },
})

export default function CheckoutBenefits({ freeCancellationDays }) {
  const intl = useIntl()
  return (
    <div className='benefits'>
      <p className='benefit'>
        <i className='font-icons ok-icon-new' />
        <FormattedMessage
          id='checkout.benefit1'
          defaultMessage='Booking usually confirmed within 24h'
        />
      </p>
      {freeCancellationDays && (
        <p className='benefit'>
          <i className='font-icons ok-icon-new' />
          <FormattedMessage
            id='48h_free_cancellation'
            defaultMessage='48h free cancellation period'
          />
        </p>
      )}
      <p
        className='benefit'
        data-tip={intl.formatMessage(messages.benefit)}
        data-for='benefits'
      >
        <i className='font-icons ok-icon-new' />
        <FormattedMessage
          id='lowest_price'
          defaultMessage='Lowest Price Guaranteed'
        />
      </p>
      <ReactTooltip type='dark' id='benefits' effect='solid' />
    </div>
  )
}
